import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ChatNavIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M9 11C9 11.8284 8.32843 12.5 7.5 12.5C6.67157 12.5 6 11.8284 6 11C6 10.1716 6.67157 9.5 7.5 9.5C8.32843 9.5 9 10.1716 9 11Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M13.5 11C13.5 11.8284 12.8284 12.5 12 12.5C11.1716 12.5 10.5 11.8284 10.5 11C10.5 10.1716 11.1716 9.5 12 9.5C12.8284 9.5 13.5 10.1716 13.5 11Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M18 11C18 11.8284 17.3284 12.5 16.5 12.5C15.6716 12.5 15 11.8284 15 11C15 10.1716 15.6716 9.5 16.5 9.5C17.3284 9.5 18 10.1716 18 11Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4.71387C2 3.21777 3.2334 2 4.75 2H22V17.2861C22 18.7822 20.7666 20 19.25 20H5.92236L2 22.5615V4.71387ZM19.25 18C19.6636 18 20 17.6797 20 17.2861V4H4.75C4.33643 4 4 4.32032 4 4.71387V18.8662L5.32764 18H19.25Z",
    fill: "currentColor"
  }));
}